import React from "react";
import ImageReveal from "./ImageReveal";

const Hero = () => {
  return (
    <section id="home" className="hero">
      <div className="hero-container">
        <div className="hero-content">
          <h1 className="hero-title">Welcome to HEM SALES AGENCIES</h1>
          <p className="hero-subtitle">
            Your partner in professional sales solutions. We help businesses
            achieve their growth objectives with innovative strategies and
            proven methodologies.
          </p>
          <div className="hero-buttons">
            <button className="btn btn-primary">Get Started Today</button>
            <button className="btn btn-secondary">Learn More</button>
          </div>
        </div>
        <div className="hero-image">
          <ImageReveal 
            src="/Images/HeroHomePageImage.jpg" 
            alt="HEM SALES AGENCIES"
            objectFit="cover"
          />
        </div>
      </div>
    </section>
  );
};

export default Hero;
